import type { TProductPart } from "./Types";

export function normalizeAttrCode(code: string): string {
    const up = code.toUpperCase();
    if (up === "ZT") { return "ZB"; }
    if (up === "ZQ") { return "ZP"; }
    return up;
}

export function setAttributeValue(attributes: TProductPart, code: string, occurrenceIndex: number, value: string) {
    const key = normalizeAttrCode(code);
    const current = attributes[key];

    // First occurrence
    if (occurrenceIndex === 0) {
        if (Array.isArray(current)) {
            // already multi -> update first slot or push if empty
            if (current.length === 0) { current.push({ index: 1, value }); }
            else { current[0] = { index: 1, value }; }
        }
        else {
            // scalar -> set scalar
            attributes[key] = value;
        }
        return;
    }

    // Second or later occurrence -> ensure it's an array with explicit indexes
    let arr: { index: number; value: string }[];
    if (Array.isArray(current)) {
        arr = current as { index: number; value: string }[];
    }
    else if (typeof current === "string") {
    // convert scalar to [first, second]
        arr = [{ index: 1, value: current }, { index: 2, value }];
    }
    else {
    // not set -> create array with placeholder(s) up to occurrenceIndex
        arr = [];
        for (let i = 0; i < occurrenceIndex; i++) {
            arr[i] = { index: i + 1, value: "" };
        }
        arr[occurrenceIndex] = { index: occurrenceIndex + 1, value };
    }

    // ensure slot exists
    if (!arr[occurrenceIndex]) { arr[occurrenceIndex] = { index: occurrenceIndex + 1, value }; }
    else { arr[occurrenceIndex].value = value; }

    attributes[key] = arr;
}
